import React, { Component } from 'react';
import { DateInput } from 'react-admin';
import { addField } from 'ra-core';

class DateBetweenInput extends Component {
  render() {
    const styles = {
      row: {
        "paddingTop": "10px",
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      },
    };

    const { source } = this.props // resource

    return (
     <span style={styles.row}>
        <DateInput style={styles.row}
          source={`${source}_gte`}
          label={`Fecha de creación mínima`}
        />
        <DateInput style={styles.row}
          source={`${source}_lte`}
          label={`Fecha de creación máxima`}
        />
      </span>
    );
  }
}

DateBetweenInput.defaultProps = {
  addLabel: true,
  label: 'Fecha de creación',
};

export default addField(DateBetweenInput);